import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { EventsService } from '../events.service';

@Component({
  selector: 'app-events-clear-filters',
  templateUrl: './events-clear-filters.component.html',
  styleUrls: ['./events-clear-filters.component.scss'],
  imports: [TranslateModule],
})
export class EventsClearFiltersComponent implements OnInit, OnDestroy {
  private eventsService = inject(EventsService);

  private readonly destroy = new Subject<void>();
  hasFilters = false;

  ngOnInit(): void {
    this.eventsService.filters
      .pipe(takeUntil(this.destroy))
      .subscribe(() => {
        const filters = this.eventsService.getFilters();
        this.hasFilters = !!(
          filters.payee_case_reference_id ||
          filters.debtor_name ||
          filters.label ||
          filters.happenedAtMin ||
          filters.happenedAtMax
        );
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  clearFilters(): void {
    this.eventsService.resetFilters();
  }
}
